<template>
    <svg aria-hidden="true" width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="17" cy="7" r="7" fill="#81DADA" />
        <rect width="10" height="14" rx="0.638889" fill="#30A29D" />
    </svg>
</template>
